import { render, staticRenderFns } from "./view-student-list.vue?vue&type=template&id=5f4ed960&"
import script from "./view-student-list.vue?vue&type=script&lang=js&"
export * from "./view-student-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports